import { render, staticRenderFns } from "./CourseIndex.vue?vue&type=template&id=a7878224"
import script from "./CourseIndex.vue?vue&type=script&lang=js"
export * from "./CourseIndex.vue?vue&type=script&lang=js"
import style0 from "./CourseIndex.vue?vue&type=style&index=0&id=a7878224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports